import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { type: String }

  connect() {
    console.log("Toast connected:", this.typeValue)
  }

  // Only remove after the toast-out animation completes
  remove(event) {
    if (event.animationName === "toast-out") {
      this.element.remove()
    }
  }
}